import { constants } from '@config';

import GraphicSetter from './abstract/graphic';

module.exports = class ShapeSetter extends GraphicSetter {
  constructor (canvas) {
    super(canvas);
    this.handledAttributes = [
      ...this.handledAttributes,
      'fill',
      'stroke',
      'data-color-group'
    ];
  }

  updateFill (element, { fill }) {
    const colorGroup = element.getAttribute('data-color-group') || '';
    if (fill.colorGroup === undefined || fill.colorGroup === colorGroup) {
      const { cmykFill } = constants.cmykAttributes;
      element.removeAttribute(cmykFill);
      this.updateAttributeNoUndo(element, 'fill', fill.color);
      this.canvas.cur_properties.fill = fill.color;

      this.trigger('fill', element.getAttribute('id'), { fill });
    }
  }

  updateColorGroup (element, { colorGroup }) {
    colorGroup && this.updateAttributeNoUndo(element, 'data-color-group', colorGroup);
  }

  updateStroke (element, { stroke }) {
    const { cmykStroke } = constants.cmykAttributes;
    element.removeAttribute(cmykStroke);

    if (typeof stroke.color !== 'undefined') {
      this.updateAttributeNoUndo(element, 'stroke', stroke.color);
      this.canvas.cur_properties.stroke = stroke.color;
    }

    if (typeof stroke.width !== 'undefined') {
      this.updateAttributeNoUndo(element, 'stroke-width', stroke.width);
    }

    if (typeof stroke.dasharray !== 'undefined') {
      this.updateAttributeNoUndo(element, 'stroke-dasharray', stroke.dasharray);
    }

    if (typeof stroke.linejoin !== 'undefined') {
      this.updateAttributeNoUndo(element, 'stroke-linejoin', stroke.linejoin);
    }

    if (typeof stroke.linecap !== 'undefined') {
      this.updateAttributeNoUndo(element, 'stroke-linecap', stroke.linecap);
    }

    this.trigger('stroke', element.id, { stroke });
  }
};
